export default {
  user: null,
  tokens: null,
}
